<template>
  <AppHeaderDropdown right no-caret v-if="$store.state.currentUser.id">
    <template slot="header">
      <i class="icon-list"></i><b-badge pill variant="warning">{{ obj ? obj.length : 0 }}</b-badge>
    </template>
    <template slot="dropdown">

      <b-list-group style="width:400px">

        <b-list-group-item href="#" class="flex-column align-items-start" variant="warning" v-if="!obj || obj.length <= 0">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1"><small>Você não tem tarefas pendentes</small></h5>
          </div>      
        </b-list-group-item>


        <b-list-group-item href="#" class="flex-column align-items-start" :variant="item.message.priority == 1 ? 'danger' : (item.message.priority == 3 ? 'secondary' : 'warning')" v-for="item in obj" :key="item.message.id" v-else>
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1"><small>{{ $utils.parseHtml(item.message.bodyText) }}</small></h5>
          </div>      
        </b-list-group-item>

      </b-list-group>

    </template>
  </AppHeaderDropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownTasks',
  components: {
    AppHeaderDropdown
  },
  props: {
    obj: Array
  },
  data: () => {
    return { 
      
    }
  }
}
</script>
